module.exports = __webpack_public_path__ + "static/media/balance.39a17a0c.svg";